"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredGroupInfoChat = void 0;
const models_1 = require("../../models");
const FilteredChat_1 = __importDefault(require("../FilteredChat"));
class FilteredGroupInfoChat extends FilteredChat_1.default {
    constructor(groupInfo, organizationUser, httpAdapter, socketAdapter, userDirectory) {
        super(groupInfo, organizationUser, httpAdapter, socketAdapter, userDirectory);
    }
    getChatId() {
        return this.chatInfo.id;
    }
    getChatType() {
        return models_1.CHAT_TYPE.GROUP;
    }
}
exports.FilteredGroupInfoChat = FilteredGroupInfoChat;
